import { useTranslation } from 'react-i18next'
import Chip from '@mui/material/Chip'
import PropTypes from 'prop-types'

import { QUOTE_INTEGRATION_STATUS, QUOTE_INTEGRATION_STATUS_LABEL } from '@/common/utils'

const statusChipColor = (status) => {
    switch (status) {
        case (status = QUOTE_INTEGRATION_STATUS['Exported']):
            return 'success.light'
        case (status = QUOTE_INTEGRATION_STATUS['NotExported']):
            return 'error.light'
        case (status = QUOTE_INTEGRATION_STATUS['Processing']):
            return 'warning.light'
        default:
            return 'secondary'
    }
}

const QuoteIntegrationChip = ({ integrationExportStatus }) => {
    const { t } = useTranslation()

    return integrationExportStatus ? (
        <Chip
            data-testid="quote-integration-status-chip"
            label={t(QUOTE_INTEGRATION_STATUS_LABEL[integrationExportStatus])}
            size="small"
            sx={{
                textTransform: 'uppercase',
                fontSize: '11px',
                backgroundColor: statusChipColor(integrationExportStatus),
                color: 'white',
                userSelect: 'none',
            }}
        />
    ) : null
}

QuoteIntegrationChip.propTypes = {
    integrationExportStatus: PropTypes.string,
}

export default QuoteIntegrationChip
